import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import {
  MENTEE_WALL_BADGES_QUERY_KEY,
  MENTEE_WALL_QUERY_KEY,
} from "@/lib/api/walls";
import { useEvents } from "@/lib/hooks/use-events";
import type { WallUpdatedPayload } from "@/lib/types/events";

export function useWallUpdates(mentorshipId: string | null) {
  const { addEventListener } = useEvents();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!mentorshipId) return;

    const unsubscribeWall = addEventListener<WallUpdatedPayload>(
      "WALL_UPDATED",
      (payload) => {
        if (payload.mentorshipId !== mentorshipId) return;
        queryClient.invalidateQueries({
          queryKey: [MENTEE_WALL_QUERY_KEY, mentorshipId],
        });
        queryClient.invalidateQueries({
          queryKey: [MENTEE_WALL_BADGES_QUERY_KEY, mentorshipId],
        });
      },
    );

    return unsubscribeWall;
  }, [addEventListener, mentorshipId, queryClient]);
}
